module.exports = __webpack_public_path__ + "static/solar-pearl-ba32ae63d6ec71d3fbe6c158769e737d.png";